import { userDetailsAtom } from '@/atoms/queries/user';
import { isInternalUser } from '@/utils/user';
import { useAtomValue } from 'jotai';

export const useShouldShowHiddenFeature = () => {
  const userDetails = useAtomValue(userDetailsAtom).data;
  return isInternalUser(userDetails);
};
